import axios from "axios";
import {
  misbarInstance,
  misbarInstanceV2,
  misbarInstanceV4,
} from "api/services/axiosInstance";
import { OFFER_URL } from "constants/ApiConstants";
import { MAP_ACCESS_TOKEN } from "constants/GeneralConstants";

const offerApi = {
  getPlacesFromMap: ({ place }) => {
    if (place.length > 2) {
      return axios.get(
        `https://api.mapbox.com/geocoding/v5/mapbox.places/${place}.json?access_token=${MAP_ACCESS_TOKEN}&country=sa&language=ar&types=poi,place`
      );
    } else {
      return true;
    }
  },
  getOffers: (
    regionId,
    provinceId,
    neighborhoodId,
    status,
    areaFrom,
    areaTo,
    isPublic
  ) =>
    misbarInstanceV4.get(`${OFFER_URL}/portal/list`, {
      params: {
        regionId,
        provinceId,
        neighborhoodId,
        status,
        areaFrom,
        areaTo,
        isPublic,
      },
    }),
  getRegions: () => misbarInstance.get("regions"),
  getOffersSettings: (regionId) =>
    misbarInstance.get(`${OFFER_URL}/portal/filters/settings`, {
      params: { regionId },
    }),
  saveOffer: (data) => misbarInstanceV4.put(`${OFFER_URL}/saveOffer`, data),
  publishOffer: (offerId) =>
    misbarInstance.put(`${OFFER_URL}/publish`, { params: { offerId } }),
  deleteOffer: (offerId, reason) =>
    misbarInstanceV2.delete(`${OFFER_URL}/delete`, {
      params: { offerId, reason },
    }),
  getOfferByToken: (token) =>
    misbarInstanceV4.get(`${OFFER_URL}/byToken`, { params: { token } }),
};

export default offerApi;
